module.exports = __webpack_public_path__ + "static/nat-6-d3244f43ef8b54590fdbee005ce406f5.jpg";